import gql from "graphql-tag";

export const uploadCollectionData = gql`
  query uploadCollectionData($input: UploadCollectionInput!) {
    uploadCollectionData(input: $input) {
      presignedUrl
    }
  }
`;

export const uploadCollectionDataOptions = {
  name: "uploadCollectionData",
};
